/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const ShieldDollar = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M12 1C13.538 2.29045 14.8713 3.12378 16 3.5C17.1287 3.87622 18.7953 4.04289 21 4V11.5982C21 14.3756 19.7177 16.9973 17.5255 18.7024L12 23L6.47453 18.7024C4.28226 16.9973 3 14.3756 3 11.5982V4C5.32585 4.00249 6.99252 3.83583 8 3.5C9.00748 3.16417 10.3408 2.33084 12 1ZM11.984 2.908L11.9672 2.92147C10.6117 3.92823 9.45907 4.59478 8.47434 4.92303C7.55818 5.22841 6.2884 5.40569 4.63475 5.47102L4.5 5.475V11.5982C4.5 13.8162 5.48136 15.9152 7.17106 17.3368L7.39545 17.5184L11.999 21.099L16.6046 17.5184C18.3553 16.1567 19.4096 14.0934 19.4945 11.8868L19.5 11.5982V5.494L19.3592 5.49092C17.9199 5.4428 16.7308 5.2833 15.7793 5.00259L15.5257 4.92303C14.4568 4.56676 13.2935 3.90203 12.0159 2.93293L11.984 2.908Z"
                        fill={color}
                    />
                    <path
                        d="M12.5691 8.33349V7.5H11.4059V8.33349C10.3617 8.52583 9.64732 9.22193 9.64732 10.1379C9.64732 11.3652 10.435 11.8415 11.3784 12.0979L12.3676 12.3727C12.7706 12.4918 13.0729 12.7116 13.0729 13.0871C13.0729 13.5176 12.6607 13.8015 12.0562 13.8015C11.3784 13.8015 10.8472 13.3069 10.7922 12.675H9.40002C9.45498 13.9023 10.2335 14.7541 11.4059 14.9739V15.8807H12.5691V15.0014C13.769 14.8457 14.52 14.1038 14.52 13.0505C14.52 11.7224 13.6957 11.2919 12.7431 11.0171L11.7448 10.7424C11.3601 10.6325 11.1036 10.4676 11.1036 10.1287C11.1036 9.75317 11.4334 9.53335 11.9829 9.53335C12.6241 9.53335 13.0179 9.91803 13.0912 10.321H14.4834C14.4284 9.25857 13.6957 8.52583 12.5691 8.33349Z"
                        fill={color}
                    />
                </svg>
        );
    };
